/* @flow */

import Note from 'models/generics/note';

export default class InvoiceNotes {
  actions: Note[];
  disclaimer: string;
  outlook: Note;
}
